import styled from 'styled-components';
import { Dropdown as SemanticDropdown } from 'semantic-ui-react';

export const FilterItemContainer = styled.div`
  display: block;
  margin-bottom: 10px;
  margin-right: 10px;
`;

export const Label = styled.label`
`;

export const Dropdown = styled(SemanticDropdown)`
`;
